import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postTravelThreeStart,
  postTravelThreeSuccess,
  postTravelThreeFailure,
} from "../reducers/postTravelThreeReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postTravelThree = createAsyncThunk(
  "postTravelThree",
  async ({ values }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postTravelThreeStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/Travel/SaveTravelSecondPage`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Set content type if necessary
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(postTravelThreeSuccess(responseData?.data?.result));
      console.log(
        responseData?.data?.result,
        "<=========responseData?.data?.result"
      );
      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postTravelThreeFailure(error.response.data.status));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
